<template>
  <div class="toggle-switch" :class="{active: value, disabled: disabled}">
    <div class="text-before" v-if="hasSlot && !textAfter" @click="$emit('input', !value)">
      <slot/>
    </div>
    <input :id="'switch-checkbox' + uuid" type="checkbox" :checked="value" @change="$emit('input', $event.target.checked)">
    <label :for="'switch-checkbox' + uuid"></label>
    <div class="text-after" v-if="hasSlot && textAfter" @click="$emit('input', !value)">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "toggleSwitch",

    props: {
      value: Boolean,
      activeColor: String,
      backgroundColor: String,
      inactiveColor: String,
      disabled: Boolean,
      size: String,
      textAfter: Boolean
    },

    data() {
      return {
        uuid: null
      }
    },

    computed: {
      hasSlot() {
        return Object.keys(this.$slots).length > 0;
      }
    },

    watch: {
      "$store.state.primaryColor"() {
        this.setActiveColor();
      },
      "$store.state.posConfiguration.darkTheme"() {
        this.setBackgroundColor()
      }
    },

    mounted() {
      this.uuid = window.generateUUID();
      this.$el.style.setProperty("--toggle-switch--size", this.size || "32px");
      this.setActiveColor();
      this.setInactiveColor();
      this.setBackgroundColor();
    },

    methods: {
      setActiveColor() {
        this.$el.style.setProperty("--toggle-switch--active-color", this.activeColor || "#fc6650");
      },
      setInactiveColor() {
        this.$el.style.setProperty("--toggle-switch--inactive-color", this.inactiveColor || "#ffffff");
      },
      setBackgroundColor() {
        this.$el.style.setProperty("--toggle-switch--background-color", this.backgroundColor || "#e6e6e6");
      }
    }
  }
</script>

<style lang="scss" scoped>
    $size: var(--toggle-switch--size);
    $height: calc(#{$size} / 3);
    $circle: calc(#{$size} / 2);

    //Default twice
    input[type=checkbox] {
      display: none;
      & + label {
        font-size: 14px;
        margin-left: 32px;
        position: relative;
        cursor: pointer;
        padding: 10px 0;
        height: 40px;
        &:after, &:before {
          content: "";
          position: absolute;
          left: -40px;
          top: 50%;
          transform: translateY(-50%);
          font-family: "Ionicons";
          font-size: 36px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:before {
          content: "\f15c";
        }
      }
      &:checked + label:after {
        content: "\f3ff";
        font-size: 30px;
        border-radius: 100%;
        margin-top: -1px;
      }
      &.invalid + label:before {
        background-color: rgba(255, 0, 0, 0.2);
      }
      &.invalid + label {
        background-color: rgba(255, 0, 0, 0.2);
      }
    }


    //Override style
    .toggle-switch {
        position: relative;
        display: flex;
        align-items: center;

        .text-before {
            padding-right: 15px;
        }
        .text-after {
            padding-left: 10px;
        }
        .text-before, .text-after {
          cursor: pointer;
        }

        &.active {
            label::before {
              background-color: var(--toggle-switch--active-color);
              opacity: 0.25;
            }
            label::after {
                background-color: var(--toggle-switch--active-color);
                left: calc(100% - #{$circle}) !important;
            }
        }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }

        label {
            width: $size;
            margin-left: 0 !important;

            &::before {
                content: "" !important;
                width: $size !important;
                height: $height !important;
                border-radius: 10px;
                border: none;
                background-color: var(--toggle-switch--background-color);
                left: initial !important;
            }

            &::after {
                content: "" !important;
                height: $circle !important;
                width: $circle !important;
                border-radius: 100%;
                box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.2);
                background-color: var(--toggle-switch--inactive-color);
                transition: all 250ms ease-in-out;
                margin: 0 !important;
                left: 0 !important;
            }
        }
    }
</style>